import { render, staticRenderFns } from "./LandingPages.vue?vue&type=template&id=617b5786&scoped=true&"
import script from "./LandingPages.vue?vue&type=script&lang=ts&"
export * from "./LandingPages.vue?vue&type=script&lang=ts&"
import style0 from "./LandingPages.vue?vue&type=style&index=0&id=617b5786&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617b5786",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
